/**
 * EnvironmentIcon/index.js
 * desc: environment icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const EnvironmentIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="environment icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.environment.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 92 95" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M88.7501 68.0748L79.2501 63.7748L54.7501 74.8748C51.9501 76.1748 48.9501 76.7748 45.8501 76.7748C42.7501 76.7748 39.7501 76.1748 36.9501 74.8748L12.4501 63.6748L2.9501 67.9748C-0.849902 69.6748 -0.849902 75.0748 2.9501 76.7748L39.8501 93.6748C43.6501 95.3748 48.0501 95.3748 51.9501 93.6748L88.8501 76.8748C92.5501 75.0748 92.5501 69.7748 88.7501 68.0748Z"/>
            <path d="M88.75 43.0749L79.25 38.7749L54.75 49.9749C51.95 51.2749 48.95 51.8749 45.85 51.8749C42.75 51.8749 39.75 51.2749 36.95 49.9749L12.35 38.7749L2.85 43.0749C-0.95 44.7749 -0.95 50.1749 2.85 51.8749L39.85 68.6749C43.65 70.3749 48.05 70.3749 51.95 68.6749L88.85 51.8749C92.55 50.1749 92.55 44.7749 88.75 43.0749Z"/>
            <path d="M2.9501 26.875L39.8501 43.775C43.6501 45.475 48.0501 45.475 51.9501 43.775L88.8501 26.975C92.6501 25.275 92.6501 19.875 88.8501 18.175L51.8501 1.275C48.0501 -0.425 43.6501 -0.425 39.7501 1.275L2.9501 18.075C-0.849902 19.875 -0.849902 25.175 2.9501 26.875Z"/>
        </svg>
    </IconButton>
);


export default EnvironmentIcon;
